// extracted by mini-css-extract-plugin
export default {"battles":"Topics_battles__AgIRn","list":"Topics_list__1JohT","tabs":"Topics_tabs__3FCKA","badge":"Topics_badge__qVhoM","empty":"Topics_empty__yqJMQ"};